import { render, staticRenderFns } from "./myChoice.vue?vue&type=template&id=161a31d5&scoped=true"
import script from "./myChoice.vue?vue&type=script&lang=js"
export * from "./myChoice.vue?vue&type=script&lang=js"
import style0 from "./myChoice.vue?vue&type=style&index=0&id=161a31d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161a31d5",
  null
  
)

export default component.exports